import { Observable, BehaviorSubject } from 'rxjs';
import { map, distinctUntilChanged, shareReplay } from 'rxjs/operators'
type MappingFunction<T, R> = (mappable: T) => R;
type MemoizationFunction<R> = (previousResult: R, currentResult: R) => boolean;

/**
 * This store takes in property and freezes it to not be changed.
 */
export class State<T> extends BehaviorSubject<T> {
    constructor(initialData: T) {
      super(initialData);
    }
  
    next(newData: T): void {
      const frozenData = newData;
        super.next(frozenData);
    }
}

function defaultMemoization(previousValue, currentValue): boolean {
  if (typeof previousValue === 'object' && typeof currentValue === 'object') {
    return naiveObjectComparison(previousValue, currentValue);
  }
  return previousValue === currentValue;
}

export function select$<T, R> (
  source$: Observable<T>,
  mappingFunction: MappingFunction<T, R>,
  memoizationFunction?: MemoizationFunction<R>
): Observable<R> {
  return source$.pipe(
    map(mappingFunction),
    distinctUntilChanged(memoizationFunction || defaultMemoization),
    shareReplay(1)
  )
}

// export function filter$<T, R>(
//   source$: Observable<T>,
//   mappingFunction: MappingFunction<T, R>,
//   memoizationFunction?: MemoizationFunction<R>
// ): Observable<R> {
//   return source$.pipe(
//     filter(item => item =),
//     distinctUntilChanged(memoizationFunction || defaultMemoization),
//     shareReplay(1)
//   )
// }

function deepFreeze<T>(inObj: T): T {
    Object.freeze(inObj);
  
    Object.getOwnPropertyNames(inObj).forEach(function (prop) {
      if (inObj.hasOwnProperty(prop)
        && inObj[prop] != null
        && typeof inObj[prop] === 'object'
        && !Object.isFrozen(inObj[prop])) {
          deepFreeze(inObj[prop]);
        }
    });
    return inObj;
  }

function naiveObjectComparison(objOne, objTwo): boolean {
return JSON.stringify(objOne) === JSON.stringify(objTwo);
}